export const NAVBAR_CONFIG = {
  1: {
    dashboard: true,

    character: {
      enabled: true,
      locations: ['totalps']
    },

    employee: {
      enabled: true,
      locations: ['totalps']
    },

    tenant: {
      enabled: true,
      locations: ['totalps']
    },

    domestic: {
      enabled: true,
      locations: ['totalps']
    },

    complaint: {
      enabled: true
    },

    postmortem: {
      enabled: false
    },

    upload: false
  },

  3: {
    dashboard: true,

    character: {
      enabled: true,
      locations: ['totalliu']
    },

    employee: {
      enabled: true,
      locations: ['totalliu']
    },

    tenant: {
      enabled: true,
      locations: ['totalliu']
    },

    domestic: {
      enabled: true,
      locations: ['totalliu']
    },

    complaint: {
      enabled: true
    },

    postmortem: {
      enabled: false
    },

    upload: false
  },

  3: {
    dashboard: true,

    character: {
      enabled: true,
      locations: ['totaldcrb']
    },

    employee: {
      enabled: true,
      locations: ['totaldcrb']
    },

    tenant: {
      enabled: true,
      locations: ['totaldcrb']
    },

    domestic: {
      enabled: true,
      locations: ['totaldcrb']
    },

    complaint: {
      enabled: true
    },

    postmortem: true,

    upload: false
  },

  51: {
    dashboard: true,

    character: {
      enabled: true,
      locations: ['totalliu', 'other_to_ownLIU']
    },

    employee: {
      enabled: true,
      locations: ['totalliu', 'other_to_ownLIU']
    },

    tenant: {
      enabled: true,
      locations: ['totalliu', 'other_to_ownLIU']
    },

    domestic: {
      enabled: true,
      locations: ['totalliu', 'other_to_ownLIU']
    },

    complaint:true,

    postmortem: true,

    upload: false
  },

   52: {
    dashboard: true,

    character: {
      enabled: true,
      locations: ['totaldcrb', 'other_to_ownDCRB']
    },

    employee: {
      enabled: true,
      locations: ['totaldcrb', 'other_to_ownDCRB']
    },

    tenant: {
      enabled: true,
      locations: ['totaldcrb', 'other_to_ownDCRB']
    },

    domestic: {
      enabled: true,
      locations: ['totaldcrb', 'other_to_ownDCRB']
    },

    complaint:true,

    postmortem: true,

    upload: false
  },

  // Admin / District
  5: {
    dashboard: true,

    character: {
      enabled: true,
      locations: [
        'remain',
        'totalps',
        'totalliu',
        'totaldcrb',
        'totaldcp',
        'totaldiff',
        'OTHER_TO_OWN_PS'
      ]
    },

    employee: {
      enabled: true,
      locations: [
        'remain',
        'totalps',
        'totalliu',
        'totaldcrb',
        'totaldcp',
        'totaldiff',
        'OTHER_TO_OWN_PS'
      ]
    },

    tenant: {
      enabled: true,
      locations: [
        'remain',
        'totalps',
        'totalliu',
        'totaldcrb',
        'totaldcp',
        'totaldiff',
        'OTHER_TO_OWN_PS'
      ]
    },

    domestic: {
      enabled: true,
      locations: [
        'remain',
        'totalps',
        'totalliu',
        'totaldcrb',
        'totaldcp',
        'totaldiff',
        'OTHER_TO_OWN_PS'
      ]
    },

    complaint: {
      enabled: true
    },

    postmortem: {
      enabled: true
    },

    upload: true
  },

  6: {
    dashboard: true,

    character: {
      enabled: true,
      locations: ['totalps', 'totalliu', 'totaldcrb']
    },

    employee: {
      enabled: true,
      locations: ['totalps', 'totalliu', 'totaldcrb']
    },

    tenant: {
      enabled: true,
      locations: ['totalps', 'totalliu', 'totaldcrb']
    },

    domestic: {
      enabled: true,
      locations: ['totalps', 'totalliu', 'totaldcrb']
    },

    complaint: {
      enabled: true
    },

    postmortem: true,

    upload: false
  },

  7: {
    dashboard: true,

    character: {
      enabled: true,
      locations: [
        'totalps',
        'totalliu',
        'totaldcrb',
        'totaldcp'
      ]
    },

    employee: {
      enabled: true,
      locations: [
        'totalps',
        'totalliu',
        'totaldcrb',
        'totaldcp'
      ]
    },

    tenant: {
      enabled: true,
      locations: [
        'totalps',
        'totalliu',
        'totaldcrb',
        'totaldcp'
      ]
    },

    domestic: {
      enabled: true,
      locations: [
        'totalps',
        'totalliu',
        'totaldcrb',
        'totaldcp'
      ]
    },

    complaint: {
      enabled: true
    },

    postmortem: true,

    upload: false
  }
};
